import { internetCard } from './Card.style';
import { LanguageRounded } from '@mui/icons-material';
import { useCommon } from '~/utils/hook/useCommon';
type TProps = {
  title: string;
  url: string;
  onLinkClick?: () => void;
};

export const InternatCard = ({ title, url, onLinkClick }: TProps) => {
  const { openExternal } = useCommon();
  return (
    <internetCard.Card
      onClick={() => {
        openExternal(url);
        onLinkClick?.();
      }}
    >
      <internetCard.IconWrapper>
        <LanguageRounded sx={{ fill: 'white' }} />
      </internetCard.IconWrapper>
      <internetCard.title>{title}</internetCard.title>
    </internetCard.Card>
  );
};
